import { App } from 'vue'
import { globalConfig } from '@loca/mfe-utils'
import { checkLogin, getAuthorizeToken, getUserInfo } from '@/biz/apis/login.api'
import { RuntimeConfigProvider } from '@nio-wad/config-provider'
import { registerConfig } from '../utils/registerConfig'
import { getChannel, getClient } from '../utils/getParams'
import { setIframeParams } from '../utils/iframeParams'

// 设置 token 存储模式，目前仅支持 'sessionStorage' | 'localStorage'
globalConfig.tokenMode = 'localStorage'

export default async ({ app }: { app: App<any> }) => {
  RuntimeConfigProvider.applyConfigToBody()
  const channelStr = getChannel()
  // 获取当前页面的url，不含参数
  const urlOriginAndPath = `${window.location.origin}${window.location.pathname}`?.replace(
    /(\/*$)/g,
    ''
  )
  // 记录url #/之后的参数
  const params = window.location.href.split('#/')[1] || ''
  if (params && !params.startsWith('oauth_callback')) {
    localStorage.setItem('params', params)
  } else {
    // 20240815后更改 需要回填的参数
    // localStorage.setItem('params', '') //
  }
  const urlParams = localStorage.getItem('params') || ''
  // console.log('===============urlParams=====================')
  // console.log(urlParams)
  // console.log('====================================')
  // 跳转前#/前的url
  const urlPre =
    channelStr.length > 0 ? `${urlOriginAndPath}?channel=${channelStr}` : `${urlOriginAndPath}`

  app.provide('channel', channelStr.length > 0 ? channelStr : 'store')
  app.provide('client', window.client || getClient())

  // 获取配置
  await registerConfig()
  // 获取组件配置
  let retryNum = 0
  let refresh = false
  const componentsConfigData = async () => {
    const res = await RuntimeConfigProvider.getConfigAsync('nsh5')
    // console.log('====================================')
    // console.log('获取在线配置', res)
    // console.log('====================================')
    if (Object.keys(res).length !== 0) {
      if (retryNum > 0 && !refresh) {
        window.location.reload()
      }
      refresh = true
      const configs = window.NSComponentsConfig || res
      document.title =
        configs.document?.show && configs.document?.properties?.title
          ? configs.document?.properties?.title
          : (process.config as any).defaultTitle // 支持在线配置title
      !window.NSComponentsConfig && (window.NSComponentsConfig = configs)

      const authRequired = !configs.login || (configs.login && configs.login?.show)

      // 在无权限页面，config配置的无需登录，跳回首页
      !authRequired &&
        window.location.hash.startsWith('#/access/denied') &&
        (window.location.href = `${urlPre}#/`)
      if (authRequired) {
        await checkLogin()
        channelStr.length > 0 &&
          localStorage.setItem(
            'channel_login',
            JSON.stringify({ channel: channelStr, time: +new Date() })
          )
        const ret: any = await getUserInfo()
        if (ret?.data?.redirect_url) {
          // waiting for sso redirecting
          await new Promise(() => {})
          return
        }
        const authorities =
          ret?.data?.authorities?.find((auth: { name: string }) => auth.name === 'Chargermap')
            ?.children || []
        const access = authorities.find((auth: { identifier: string }) =>
          auth.identifier.startsWith('chargermap:access')
        )
        console.log('================authRequired====================')
        console.log(authorities, access)
        console.log('====================================')
        if (configs?.implant?.show) {
          // 允许被嵌入的情况下不需要校验权限，只校验登录
        } else {
          // 不允许被嵌入的情况下需要校验权限
          if (!access) {
            if (!window.location.hash.startsWith('#/access/denied')) {
              return (window.location.href = `${urlPre}#/access/denied`)
            } else {
              return
            }
          }
        }
        const ssoPath = '/oauth_callback'
        if (
          window.location.pathname === ssoPath ||
          window.location.hash.startsWith(`#${ssoPath}`)
        ) {
          window.location.href = `${urlPre}#/`
        }

        // 在无权限页面，有权限跳回首页
        window.location.hash.startsWith('#/access/denied') && (window.location.href = `${urlPre}#/`)
        // 跳回带上记录的channel
        const entryObject = JSON.parse(localStorage.getItem('channel_login') || '{}')
        entryObject.channel?.length > 0 && (window.location.href = `${urlPre}#/${urlParams}`)
        setIframeParams()
        if (configs?.digital_twin_entrance?.show) {
          // 调用数字孪生需要powergo那边的登录token
          const authorizeToken = await getAuthorizeToken()
          app.provide('authorizeToken', authorizeToken)
        }
      }
    } else {
      if (retryNum < 3) {
        // 重试，1-5秒内随机时间重试
        const randomTime = Math.round(Math.random() * 5 * 1000)
        setTimeout(() => {
          // 重试执行 getComponentsConfig方法
          retryNum++
          componentsConfigData()
        }, randomTime)
      }
    }
  }
  await componentsConfigData()
  localStorage.removeItem('channel_login')
  localStorage.removeItem('params')
}
